import { render, staticRenderFns } from "./TokenRedirect.vue?vue&type=template&id=4f966ddf&scoped=true&"
import script from "./TokenRedirect.vue?vue&type=script&lang=js&"
export * from "./TokenRedirect.vue?vue&type=script&lang=js&"
import style0 from "./TokenRedirect.vue?vue&type=style&index=0&id=4f966ddf&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f966ddf",
  null
  
)

export default component.exports